// js
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import classnames from 'classnames';


const DSATabDropdown = ({subLinks, name, showExtensions, baseNavRoute}) => {
  const renderSubmenu = subLink => (
    subLink.active &&
    showExtensions &&
    subLink.extensions &&
    !!subLink.extensions.length
  );

  return (
    <ul className='nav dropdown-menu'>
      {subLinks.map(subLink =>
        (<li key={subLink.name} className={classnames({disabled: !subLink.active})}>
          <Link
            to={`${baseNavRoute}/${name}/${subLink.name}`}
          >
            {subLink.title}
          </Link>

          {renderSubmenu(subLink) &&
            <ul className='nav dropdown-menu dropdown-submenu'>
              {subLink.extensions.map(ext =>
                (<li key={ext.name}><Link to={`${baseNavRoute}/${ext.name}`}>{ext.title}</Link></li>)
              )}
            </ul>
          }
        </li>)
      )}
    </ul>
  );
};

DSATabDropdown.propTypes = {
  subLinks: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  showExtensions: PropTypes.bool,
  baseNavRoute: PropTypes.string.isRequired
};

export default DSATabDropdown;



// WEBPACK FOOTER //
// ./src/components/DSATabDropdown.js